<template>
  <TableLayout :permissions="['business:integral:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="用户" prop="nickName">
        <el-input v-model="searchForm.nickName" placeholder="请输入用户昵称/或手机号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="获得/扣除" prop="type">
        <el-select v-model="searchForm.type"    placeholder="请选择收支类型"   @change="search" >
          <el-option :key="0" :value="0" label="获得"></el-option>
          <el-option :key="1" :value="1" label="扣除"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联订单号" prop="orderCode">
        <el-input v-model="searchForm.orderCode" placeholder="请输入平台订单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="消费类型" prop="objType">
        <el-select v-model="searchForm.objType"    placeholder="请选择消费类型"   @change="search" >
          <el-option :key="0" :value="0" label="注册成功"></el-option>
          <el-option :key="3" :value="3" label="邀请好友得积分"></el-option>
          <el-option :key="12" :value="12" label="积分发放"></el-option>
          <el-option :key="13" :value="13" label="积分扣除"></el-option>
          <el-option :key="9" :value="9" label="下单抵扣"></el-option>
          <el-option :key="14" :value="14" label="取消订单退回"></el-option>
          <el-option :key="15" :value="15" label="消费返积分"></el-option>
          <el-option :key="18" :value="18" label="积分过期"></el-option>
        </el-select>
      </el-form-item>
      <div class="date-style" style="display: inline">
        <el-form-item label="变动时间" prop="starttime" >
          <el-date-picker
              style="width: 160px"
              clearable
              v-model="searchForm.starttime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              placeholder="开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="-" label-width="10px" prop="endtime" >
          <el-date-picker
              style="width: 160px"
              clearable
              v-model="searchForm.endtime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              placeholder="截止时间"
          ></el-date-picker>
        </el-form-item>
      </div>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
<!--
        <el-button type="primary" :loading="isWorking.export" v-permissions="['business:integral:exportExcel']" @click="exportExcel">导出</el-button>
-->
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
<!--         <el-table-column prop="remark" label="流水号" align="center" min-width="100px"></el-table-column>-->
        <el-table-column prop="nickName" label="用户" align="center" min-width="100px"> </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号" min-width="100px"></el-table-column>
        <el-table-column prop="type" align="center" label="收支类型" min-width="100px">
          <template slot-scope="{row}">
           <span v-if="row.type==0" class="green">获得</span>
           <span v-else class="red">扣除</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" align="center" label="数量" min-width="100px"></el-table-column>
        <el-table-column prop="totalNum" align="center" label="当前余额" min-width="100px"></el-table-column>
        <el-table-column prop="strObjType" align="center" label="消费类型" min-width="100px"></el-table-column>
        <el-table-column prop="content" align="center" label="变动内容" min-width="150px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderCode" align="center" label="交易单号" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" align="center" label="变动时间" min-width="100px"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'Integral',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      createDate: [],
      // 搜索
      searchForm: {
        nickName: '',
        userType: 0,
        type: '',
        starttime: '',
        objType: null,
        endtime: '',
        orderCode: ''
      }
    }
  },
  created () {
    this.config({
      module: '用户积分明细表',
      api: '/business/integral',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    selectDate(v) {
      this.searchForm.starttime = v[0] + '00:00:00'
      this.searchForm.endDate = v[1] + '23:59:59'
      this.search()
    },
    reset () {
      this.createDate = []
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.$refs.searchForm.resetFields()
      this.search()
    }
  }
}
</script>
